<template>
  <div>
    <div class="tagTitle">
      <van-tag type="success">项目信息</van-tag>
    </div>
    <div class="card" style="min-height: 0px;margin: 0; padding: 0;" v-if="execCustomerName">
      <div class="list-wrap van-hairline--top">
        <div class="item" style="padding-left:70px;text-indent:-70px;">
          <span class="key">执行客户：</span>
          <span class="value">{{ execCustomerName }}</span>
        </div>
        <div class="item" v-if="agentBusinessMoney || agentBusinessMoney == 0">
          <span class="key">代运营服务费：</span>
          <span class="value" style="color: #ee0a24;">{{ agentBusinessMoney }}%</span>
        </div>
      </div>
    </div>
    <van-list v-if="projectList.length > 0" >
      <van-cell v-for="(item,index) in projectList" :key="index" style="padding: 6px;">
        <div class="flex-between" v-if="item" style="align-items: flex-start">
          <div>
            <div class="item" style="padding-left:70px;text-indent:-70px;">
              <span class="key"> 项目名称：</span>
              <span class="value"><span style="color: #ee0a24;">{{ `【${item.percentage}%/${item.calculationMethodStr}】` }}</span>{{`：${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}}</span>
            </div>
            <template v-if="contInfo.channelType == 2">
              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key">执行客户：</span>
                <span class="value">{{ item.execCustomerName }}</span>
              </div>
              <div class="item">
                <span class="key">代运营服务费：</span>
                <span class="value" style="color: #ee0a24;">{{ item.agentBusinessMoney }}%</span>
              </div>
            </template>
            <div class="item">
              <span class="key"> 返点百分比值(%)：</span>
              <span class="value" style="color: #ee0a24;">{{ item.percentage }}%</span>
            </div>
          </div>
        </div>
        <van-button style="margin: 0px auto; width: 30%" class="topBtn" round block type="info" native-type="button" size="mini" @click="pointDetail(item)">返点详情</van-button>
      </van-cell>
    </van-list>
    <!-- 项目返点信息 -->
    <van-dialog v-model="projectPointVisible" title="返点详情" width="95%" style="height:60%;"  :close-on-click-overlay="true" :showConfirmButton = 'false'>
      <van-list v-if="projectPointList.length > 0" style="margin-top: 10px">
        <van-cell v-for="(item,index) in projectPointList" :key="index">
          <div class="flex-between" v-if="item" style="align-items: flex-start">
            <div>
              <template v-if="$store.state.user.user.userId === 1 || $store.state.user.user.userId === 539">
                <div class="item">
                  <span class="key"> 客户返点百分比值(%)：</span>
                  <span class="value">{{ item.percentageChannel }}%</span>
                </div>
                <div class="item">
                  <span class="key"> 返点消耗(元)：</span>
                  <span class="value" style="color: #ee0a24;">{{ item.useMoney || '--' }}</span>
                </div>
              </template>
              <div class="item">
                <span class="key"> 返点百分比值(%)：</span>
                <span class="value">{{ item.percentage }}%</span>
              </div>

              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key"> 执行时间：</span>
                <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
              </div>
            </div>
          </div>
        </van-cell>
        <van-cell style="color: #ee0a24;" :title="'注：请留意返点执行时间，如当前时间大于执行结束时间，返点会按 0% 计算'" />
      </van-list>
      <Empty v-if="projectPointList.length == 0"></Empty>
    </van-dialog>
  </div>
</template>

<script>
import newContract from '@/api/cont/newContract'
import payment from '@/api/cont/payment'
import Empty from '@/components/common/Empty'
import { Dialog, Toast } from 'vant'

export default {
  components: {
    Empty,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      bussType: null,
      bussId: null,
      execCustomerName: null,
      agentBusinessMoney: null,
      projectList: [],
      projectPointList: [],
      projectPointVisible: false,

      contInfo: {}
    }
  },
  mounted() {

  },
  methods: {
    async getProjectList(type, val, execCustomerName, agentBusinessMoney, projectId) {
      this.bussType = type
      this.bussId = val
      this.execCustomerName = execCustomerName
      this.agentBusinessMoney = agentBusinessMoney
      await newContract.listProjectPercentage({ bussType: type, bussId: val, projectId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
      if (type == 1) {
        await newContract.getContract(val).then(res => {
          if (res.code === 200) {
            this.contInfo = res.data
          }
        })
      }
    },
    // 项目返点信息
    pointDetail(row) {
      if (this.bussType == '1' && this.contInfo.channelType != 2) {
        newContract.getRebateList({ contractId: this.bussId, projectId: row.projectId }).then(res => {
          this.projectPointList = res.rows
          this.projectPointVisible = true
        })
      } else if (this.bussType == '1' && this.contInfo.channelType == 2) {
        payment.getRebateList({ execCustomerId: row.execCustomerId, projectId: row.projectId }).then(res => {
          this.projectPointList = res.rows
          this.projectPointVisible = true
        })
      } else if (this.bussType == '2') {
        payment.getRebateList({ execCustomerId: this.bussId, projectId: row.projectId }).then(res => {
          this.projectPointList = res.rows
          this.projectPointVisible = true
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 82%;
}
.tagTitle{
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
